import { useLang } from 'hooks/lang';

import { invoiceControlStatusConfig } from 'entities';

import { Link, Popover, Row } from 'components/Blocks';
import {
  CircleDollarIcon,
  FolderIcon,
  LightningIcon,
  PackageCheckIcon,
  ReceiptLongIcon,
  ShoppingCartIcon,
  UserBookIcon,
} from 'components/Icons';

import { SideLink } from './SideLink';

import { useToggleV2, useUser } from 'hooks';

const links = [
  {
    icon: ReceiptLongIcon,
    label: 'invoices',
    to: 'invoices',
  },
  {
    icon: FolderIcon,
    label: 'projects',
    to: 'invoiceProjectsByStatus',
    params: { status: invoiceControlStatusConfig.readyToInvoice.routeId },
  },
  {
    icon: ShoppingCartIcon,
    label: 'outsource-invoices',
    to: 'outsourceInvoices',
  },
  {
    icon: PackageCheckIcon,
    label: 'packages',
    to: 'packages',
  },
  {
    icon: UserBookIcon,
    label: 'client-balances',
    to: 'clientsBalance',
  },
];

export function InvoiceLink() {
  const { t } = useLang();

  const { team } = useUser();

  const [show, showHandlers] = useToggleV2();
  const [isHoveringMenu, hoverHandlers] = useToggleV2();

  if (!team.isInvoiceTeam) return null;

  const fullClose = () => {
    showHandlers.turnOff();
    hoverHandlers.turnOff();
  };

  const closePopOver = () => {
    setTimeout(() => {
      if (show && isHoveringMenu) return fullClose();

      if (isHoveringMenu) return;

      showHandlers.turnOff();
    }, 150);
  };

  const onMenuBlur = () => {
    setTimeout(() => {
      if (show && isHoveringMenu) return fullClose();

      if (show) return;

      hoverHandlers.turnOff();
    }, 150);
  };

  return (
    <>
      <Popover
        side="right"
        isOpen={show || isHoveringMenu}
        close={showHandlers.turnOff}
        className="p-2"
        align="start"
        sideOffset={5}
        byPassTrigger={
          <div
            className="w-full self-stretch"
            onMouseEnter={showHandlers.turnOn}
            onMouseLeave={closePopOver}
            onClick={showHandlers.turnOff}
          >
            <SideLink
              to="invoiceHome"
              label={t('invoice-home')}
              disableTooltip
              icon={<CircleDollarIcon size={22} />}
            />
          </div>
        }
      >
        <div
          className="flex flex-col gap-1.5"
          onMouseEnter={hoverHandlers.turnOn}
          onMouseLeave={onMenuBlur}
        >
          <Row gap="2" className="mb-1 text-xs font-semibold text-primary">
            <LightningIcon size={12} />
            <span>{t('quick-access')}</span>
          </Row>

          {links.map(({ icon: Icon, label, ...params }) => (
            <Link
              className="flex items-center gap-2 rounded-md px-1 py-0.5 text-sm hover:bg-hover"
              key={label}
              onClick={hoverHandlers.turnOff}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              {...(params as any)}
            >
              <Icon size={14} />
              {t(label)}
            </Link>
          ))}
        </div>
      </Popover>
    </>
  );
}
